/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConversioneDettaglioCreateDTO
 */
export interface ConversioneDettaglioCreateDTO {
    /**
     * 
     * @type {number}
     * @memberof ConversioneDettaglioCreateDTO
     */
    indiceConversione?: number;
    /**
     * 
     * @type {number}
     * @memberof ConversioneDettaglioCreateDTO
     */
    percentuale?: number;
}

/**
 * Check if a given object implements the ConversioneDettaglioCreateDTO interface.
 */
export function instanceOfConversioneDettaglioCreateDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ConversioneDettaglioCreateDTOFromJSON(json: any): ConversioneDettaglioCreateDTO {
    return ConversioneDettaglioCreateDTOFromJSONTyped(json, false);
}

export function ConversioneDettaglioCreateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConversioneDettaglioCreateDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'indiceConversione': !exists(json, 'indiceConversione') ? undefined : json['indiceConversione'],
        'percentuale': !exists(json, 'percentuale') ? undefined : json['percentuale'],
    };
}

export function ConversioneDettaglioCreateDTOToJSON(value?: ConversioneDettaglioCreateDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'indiceConversione': value.indiceConversione,
        'percentuale': value.percentuale,
    };
}

